import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import dayjs from 'dayjs';

export const YEAR_ONLY_FORMATS = {
  parse: { dateInput: 'YYYY' },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'YYYY',
    monthYearA11yLabel: 'YYYY'
  }
};

@Component({
  selector: 'app-year-picker',
  templateUrl: './year-picker.component.html',
  styleUrls: ['./year-picker.component.css'],
  standalone: false,
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: YEAR_ONLY_FORMATS }
  ]
})
export class YearPickerComponent {
  @Input() value: string = null;
  @Input() placeholder: string = '—';
  @Output() yearChange = new EventEmitter<string>();

  getYear(): string {
    if (!this.value) return '';
    return dayjs(this.value).format('YYYY');
  }

  onYearSelected(event: any, picker: MatDatepicker<any>): void {
    const year = event.year ? event.year() : dayjs(event).year();
    const formatted = `${year}-01-01T00:00:00.000+02:00`;
    this.value = formatted;
    this.yearChange.emit(formatted);
    setTimeout(() => picker.close());
  }
}
